import { ProductReviews } from '@/features/product-reviews/ui/ProductReviews';

export { ProductReviews };
